import { ITypeaheadSuggestion, Tag } from '@cian/components';
import * as React from 'react';
import { connect } from 'react-redux';

import { ICommercialSpecialty } from '../../../../api/commercial_specialties';
import { IAppState, Dispatch } from '../../../../common/state';
import { getTermsValue } from '../../../../json_query/reducers/helpers';

import {
  addCommercialSpecialtyTypeMeta,
  addSpecialtyTypes,
  removeSpecialtyTypes,
} from '../../../state/advanced/specialty_types';
import { InlineParam, Row } from '../markup';
import { Autocomplete, IAutocompleteSuggestion } from '../../../../common/components/autocomplete';

const styles = require('./specialty_types.css');

export interface ISpecialtyTypesProps {
  commercialSpecialties: ICommercialSpecialty[];
  types: number[];

  addCommercialSpecialtyTypeMeta(value: ICommercialSpecialty): void;
  addSpecialtyTypes(value: number): void;
  removeSpecialtyTypes(value: number): void;
}

export interface ISpecialtyTypesState {
  selected?: ITypeaheadSuggestion;
  searchString: string;
}

export interface ISuggestionView {
  label: string;
  value: string;
}

export class SpecialtyTypes extends React.PureComponent<ISpecialtyTypesProps, ISpecialtyTypesState> {
  public state = {
    searchString: '',
  };

  public render() {
    const { commercialSpecialties, types } = this.props;

    const validTypes = commercialSpecialties.filter(({ id, rusName }) => id && rusName && types.includes(id));
    const validTypesIds = validTypes.map(i => i.id);
    const suggestions = Array.from(commercialSpecialties).reduce(
      (acc: ISuggestionView[], next: ICommercialSpecialty) => {
        if (next.id && !validTypesIds.includes(next.id) && next.rusName) {
          acc.push({
            label: next.rusName,
            value: next.id.toString(),
          });
        }

        return acc;
      },
      [],
    );

    return (
      <Row title="Возможное назначение">
        <InlineParam>
          <div className={styles['input']}>
            <Autocomplete
              placeholder="Выберите возможное назначение"
              suggestions={suggestions}
              onSelect={this.handleSelect}
            />
          </div>
          {validTypes.map(({ id, rusName }) => (
            <Tag
              tagStyles={styles['tag']}
              key={`specialty-type-${id}`}
              onDeleteClick={this.props.removeSpecialtyTypes.bind(null, id)}
            >
              {rusName}
            </Tag>
          ))}
        </InlineParam>
      </Row>
    );
  }

  private handleSelect = (suggestion: IAutocompleteSuggestion<string>) => {
    const { commercialSpecialties } = this.props;
    const valueNumber = Number(suggestion.value);
    const currentSpecialty = commercialSpecialties.find(f => f.id === valueNumber);

    if (currentSpecialty && currentSpecialty.id) {
      this.props.addCommercialSpecialtyTypeMeta(currentSpecialty);
      this.props.addSpecialtyTypes(currentSpecialty.id);
    }
  };
}

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => {
    const { jsonQuery } = state.filters;

    return {
      commercialSpecialties: state.specialties,
      makeRequest: state.makeRequest,
      types: getTermsValue('specialty_types')(jsonQuery),
    };
  },
  (dispatch: Dispatch) => ({
    addCommercialSpecialtyTypeMeta: (value: ICommercialSpecialty) => dispatch(addCommercialSpecialtyTypeMeta(value)),
    addSpecialtyTypes: (value: number) => dispatch(addSpecialtyTypes(value)),
    removeSpecialtyTypes: (value: number) => dispatch(removeSpecialtyTypes(value)),
  }),
)(SpecialtyTypes);
